module.exports = __webpack_public_path__ + "img/iconlist-3.07a6e2ad.png";